/**
 * Admin Page
 *
 * Admin interface with tabs for:
 * - Superusers management
 * - Customers management
 * - Organization and employee settings
 */

import type { TabItem } from "@/components/ui/navigation/Tabs";
import { Tabs } from "@/components/ui/navigation/Tabs";
import { SectionHeader } from "@/components/ui/navigation/SectionHeader";
import { CustomersSection } from "@/components/admin/CustomersSection";
import { SettingsSection } from "@/components/admin/SettingsSection";
import { SuperusersSection } from "@/components/admin/SuperusersSection";
import React, { useMemo } from "react";
import styles from "./AdminPage.module.css";

export const AdminPage: React.FC = () => {
  // Define tabs
  const tabs: TabItem[] = useMemo(
    () => [
      {
        id: "superusers",
        label: "Superbrukere",
        content: <SuperusersSection />,
      },
      {
        id: "customers",
        label: "Kunder",
        content: <CustomersSection />,
      },
      {
        id: "settings",
        label: "Konfigurasjon",
        content: <SettingsSection />,
      },
    ],
    [],
  );

  return (
    <div className={styles.page} data-testid="admin-page">
      <SectionHeader as="h1" size="lg" className={styles.title}>
        Administrasjonspanel
      </SectionHeader>
      <Tabs tabs={tabs} defaultTab="superusers" data-testid="admin-tabs" />
    </div>
  );
};

export default AdminPage;
